<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>

<div class="row" *ngIf="isLoading == 2">
  <img class="imgBack" (click)="backBtn()" src="assets/img/backbtn.png" alt="Back" />
</div>

<div class="leftSection1">
  <!-- Template macro summary row -->
  <div class="row mt-2" *ngIf="templateMeta?.calsNeeded != null || templateMeta?.proteinGoal != null || templateMeta?.carbsGoal != null || templateMeta?.fatsGoal != null">
    <div class="col-12 planMetaRow">
      <span class="metaItem"><span class="metaLabel">Daily Target:</span> {{templateMeta?.calsNeeded}} cal</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Deficit:</span> {{templateMeta?.caloriesDeficitGoal ?? 0}}</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Protein:</span> {{templateMeta?.proteinGoal}} g</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Fats:</span> {{templateMeta?.fatsGoal}} g</span>
      <span class="metaSep">|</span>
      <span class="metaItem"><span class="metaLabel">Carbs:</span> {{templateMeta?.carbsGoal}} g</span>
    </div>
  </div>

  <div class="row mt-5" *ngIf="planDetails.length < 1 && error === 1">
    <div class="col notFound">
      <p>Template not found</p>
    </div>
  </div>

  <div *ngFor="let plan of planDetails; let i = index">
    <!-- Day header only (no date per user request) -->
    <div class="row mt-5 ml-1">
      <div class="col">
        <p class="dt">{{ plan.day }}</p>
      </div>
    </div>

    <ng-container *ngFor="let item of getTimelineItems(plan)">
      <!-- Fasting card -->
      <div *ngIf="item.type === 'fasting' && item.fasting">
        <div class="col mt-3">
          <p class="dt1">Fasting</p>
        </div>
        <div class="row">
          <div class="col-sm-4 mt-1">
            <div class="tileFast">
              <div class="row">
                <div class="col-2">
                  <img width="60" src="/assets/img/fastingIcon.png" alt="Fasting" />
                </div>
                <div class="col-10"></div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="col">
                    <span class="dt1">From:</span>&nbsp;&nbsp;<span class="dt2">{{ item.fasting.fromTime }}</span>
                  </div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col">
                    <span class="dt1">To:</span>&nbsp;&nbsp;<span class="dt2">{{ item.fasting.toTime }}</span>
                  </div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col">
                    <span class="dt1">Duration:</span>&nbsp;&nbsp;<span class="dt2">{{
                      convertSecondsToHoursAndMinutes(item.fasting.duration)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Meal card -->
      <div *ngIf="item.type === 'meal' && item.meal">
        <div class="col mt-3">
          <p class="dt1">{{ item.meal.mealType }}, Time : {{ item.meal.mealTime }}</p>
        </div>
        <div class="row">
          <div class="col-sm-4 mt-1" *ngFor="let rec of item.meal.mealRecipe">
            <div class="tiles mt-2">
              <div class="row">
                <div class="col-md-9">
                  <div class="pack" *ngIf="rec.recipeType == 'Packaged'">
                    <p style="padding: 10px;">Packaged Food</p>
                  </div>
                  <div class="rest" *ngIf="rec.recipeType == 'Restaurant'">
                    <p style="padding: 10px;">Restaurant Food</p>
                  </div>
                  <div class="diy" *ngIf="rec.recipeType == 'DIY' || rec.recipeType == 'FreshProduce'">
                    <p style="padding: 10px;">Do It Yourself</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <img class="editImg" src="assets/img/view.png" alt="View" />
                  <label class="editLabel" (click)="viewRecipe(plan, item.meal, rec)">View</label>
                </div>
              </div>
              <div class="row">
                <div class="col mealName">{{ rec.recipeName }}</div>
              </div>
              <div class="row mt-3">
                <div class="col recDetails">
                  <span>{{ rec.measurement?.value }} {{ rec.measurement?.unit }}</span>&nbsp;
                  <span><img width="10" src="assets/img/calories.png" alt="" /></span>&nbsp;
                  <span>{{ rec.nutrition?.calories }} Kcal</span>
                  &nbsp;<span><img width="8" src="assets/img/protien-old.png" alt="" /></span>&nbsp;
                  <span>{{ rec.nutrition?.protein }} g of Protein</span>
                  &nbsp;<span><img width="10" src="assets/img/carbs.png" alt="" /></span>&nbsp;
                  <span>{{ rec.nutrition?.carbs }} g of Carbs</span>
                  &nbsp;<span><img width="10" src="assets/img/fat.png" alt="" /></span>&nbsp;
                  <span>{{ rec.nutrition?.fat }} g of Fats</span>
                </div>
              </div>
              <div class="row mt-4" *ngIf="rec.diyRecipeData != null && rec.diyRecipeData.ingredients?.length">
                <div
                  class="col-lg-6"
                  [ngClass]="{ ingrDetails1: idx % 2 === 0, ingrDetails: idx % 2 !== 0 }"
                  *ngFor="let ingr of rec.diyRecipeData.ingredients; let idx = index"
                >
                  {{ ingr.ingredientName }} ({{ ingr.measurement?.quantity }} {{ ingr.measurement?.unit }})
                </div>
              </div>
              <div
                class="row mt-4"
                *ngIf="rec.restaurantRecipeData != null && rec.restaurantRecipeData.ingredients?.length"
              >
                <div
                  class="col-lg-6"
                  [ngClass]="{ ingrDetails1: idx % 2 === 0, ingrDetails: idx % 2 !== 0 }"
                  *ngFor="let ingr of rec.restaurantRecipeData.ingredients; let idx = index"
                >
                  {{ ingr.ingredientName }} ({{ ingr.measurement?.quantity }} {{ ingr.measurement?.unit }})
                </div>
              </div>
              <div
                class="row mt-4"
                *ngIf="rec.packagedRecipeData != null && rec.packagedRecipeData.ingredients?.length"
              >
                <div
                  class="col-lg-6"
                  [ngClass]="{ ingrDetails1: idx % 2 === 0, ingrDetails: idx % 2 !== 0 }"
                  *ngFor="let ingr of rec.packagedRecipeData.ingredients; let idx = index"
                >
                  {{ ingr.ingredientName }} ({{ ingr.measurement?.quantity }} {{ ingr.measurement?.unit }})
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- View Recipe Modal (read-only DIY/recipe data) -->
<div
  class="modal fade"
  id="viewRecipeModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="viewRecipeModalLabel"
  data-bs-backdrop="static"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header">
        <span class="title1">Recipe Details</span>
        <button type="button" class="close" aria-label="Close" (click)="closeViewRecipeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="viewRecipeObj">
        <div class="row mt-1">
          <div class="col-md-12">
            <span class="editSubText">Name</span>
            <p class="modalText">{{ viewRecipeObj.recipeName }}</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <span class="editSubText">Nutrition</span>
            <p class="modalSubText">
              {{ viewRecipeObj.nutrition?.calories }} Kcal &nbsp;|&nbsp;
              {{ viewRecipeObj.nutrition?.protein }} g Protein &nbsp;|&nbsp;
              {{ viewRecipeObj.nutrition?.carbs }} g Carbs &nbsp;|&nbsp;
              {{ viewRecipeObj.nutrition?.fat }} g Fats
            </p>
          </div>
        </div>
        <div class="row mt-4" *ngIf="viewRecipeObj.ingredients?.length">
          <div class="col title1">Ingredients</div>
        </div>
        <div class="row mt-2" *ngIf="viewRecipeObj.ingredients?.length">
          <div class="col-md-6" *ngFor="let ing of viewRecipeObj.ingredients">
            <span class="ingrDetails">{{ ing }}</span>
          </div>
        </div>
        <div class="row mt-4" *ngIf="viewRecipeObj.instructions?.length">
          <div class="col title1">Instructions</div>
        </div>
        <div class="row mt-2" *ngIf="viewRecipeObj.instructions?.length">
          <div class="col-md-12">
            <ol class="modalSubText">
              <li *ngFor="let step of viewRecipeObj.instructions">{{ step }}</li>
            </ol>
          </div>
        </div>
        <!-- Brand details (from restaurantRecipeData or packagedRecipeData when present) -->
        <div class="row mt-4" *ngIf="viewRecipeObj.brandDetails">
          <div class="col title1">Brand details</div>
        </div>
        <div class="row mt-2" *ngIf="viewRecipeObj.brandDetails">
          <div class="col-md-12">
            <p class="modalSubText" *ngIf="viewRecipeObj.brandDetails.brand">
              <span class="editSubText">Name:</span> {{ viewRecipeObj.brandDetails.brand }}
            </p>
            <p class="modalSubText" *ngIf="viewRecipeObj.brandDetails.barcode != null">
              <span class="editSubText">Barcode:</span> {{ viewRecipeObj.brandDetails.barcode || '—' }}
            </p>
            <p class="modalSubText" *ngIf="viewRecipeObj.brandDetails.logo">
              <span class="editSubText">Logo:</span>
              <img [src]="viewRecipeObj.brandDetails.logo" alt="Brand logo" class="brandLogo" />
            </p>
          </div>
        </div>
        <!-- Available in (stores from API when present) -->
        <div class="row mt-4" *ngIf="viewRecipeObj.stores?.length">
          <div class="col title1">Available in</div>
        </div>
        <div class="row mt-2" *ngIf="viewRecipeObj.stores?.length">
          <div class="col-md-12">
            <div class="storeCard mt-2" *ngFor="let store of viewRecipeObj.stores">
              <div class="row align-items-center">
                <div class="col-auto" *ngIf="store.logo">
                  <img [src]="store.logo" alt="" class="storeLogo" />
                </div>
                <div class="col">
                  <span class="editSubText">Name: {{ store.storeName }}</span>
                  <p class="modalSubText mb-0" *ngIf="store.location">Location: {{ store.location }}</p>
                  <a *ngIf="store.website" [href]="store.website" target="_blank" rel="noopener noreferrer" class="storeLink">Website: {{ store.website }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <button type="button" class="btn btnConfirm1 btnLabel1" (click)="closeViewRecipeModal()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

